import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import whyIconDurable from "../../assets/images/icons/durable.webp";
import whyIconInstall from "../../assets/images/icons/easy-installation.webp";
import whyIconHealth from "../../assets/images/icons/healthcare.webp";
import whyIconPhLevel from "../../assets/images/icons/ph.webp";
import ioniaMachine from "../../assets/images/products/x-blue/img2.webp";

function HomeWhyPureIonia() {
  return (
    <section className="why_ionia__wrapper">
      <Container>
        <Row>
          <Col md={12}>
            <div className="title__wrap center_aligned regular mb-5">
              <h2>Why To Choose Pure Ionia Water Ionizer Machine?</h2>
            </div>
          </Col>
          <Col md={7}>
            <div className="rounded-2 bg-white ionia_item">
              <div className="icon">
                <picture>
                  <source srcSet={whyIconDurable} type="image/webp" />
                  <img src={whyIconDurable} alt="Unmatched Durability" />
                </picture>
              </div>
              <div className="content">
                <h3>Unmatched Durability</h3>
                <p>
                  Our ionizers are built to withstand the test of time, offering
                  exceptional longevity of up to 20 to 25 years. Invest in a
                  durable solution that ensures consistent performance for
                  decades to come.
                </p>
              </div>
            </div>
            <div className="rounded-2 bg-white ionia_item">
              <div className="icon">
                <picture>
                  <source srcSet={whyIconPhLevel} type="image/webp" />
                  <img src={whyIconPhLevel} alt="Customizable pH Levels" />
                </picture>
              </div>
              <div className="content">
                <h3>Customizable pH Levels</h3>
                <p>
                  Experience the ultimate versatility with our ionizers,
                  providing three types of water - Alkaline, Acidic, and
                  Filtered. From 2.5pH to 11.5pH, you have the power to
                  customize your water based on your unique needs and
                  preferences.
                </p>
              </div>
            </div>
            <div className="rounded-2 bg-white ionia_item">
              <div className="icon">
                <picture>
                  <source srcSet={whyIconInstall} type="image/webp" />
                  <img src={whyIconInstall} alt="Easy Installation" />
                </picture>
              </div>
              <div className="content">
                <h3>Easy Installation</h3>
                <p>
                  Say goodbye to complex installations. Our user-friendly
                  ionizers are designed for effortless setup, allowing you to
                  start enjoying the benefits of alkaline water quickly and
                  conveniently.
                </p>
              </div>
            </div>
            <div className="rounded-2 bg-white ionia_item">
              <div className="icon">
                <picture>
                  <source srcSet={whyIconHealth} type="image/webp" />
                  <img src={whyIconHealth} alt="Countless Health Benefits" />
                </picture>
              </div>
              <div className="content">
                <h3>Countless Health Benefits</h3>
                <p>
                  Unlock a world of health advantages with our ionizers.
                  Experience anti-aging properties, weight loss support,
                  enhanced immunity, improved digestion, better liver and kidney
                  health, stronger bones, joint lubrication, and relief from
                  constipation.
                </p>
              </div>
            </div>
          </Col>
          <Col md={5} className="ps-2 pt-5 pt-md-0 ps-md-5">
            <div className="title__wrap">
              <h2>
                Protect your family with one of the best water lonizer systems
              </h2>
            </div>
            <div className="text-center offset-md-0 wow zoomIn center">
              <picture>
                <source srcSet={ioniaMachine} type="image/webp" />

                <img src={ioniaMachine} className="w-100 h-auto   " alt="" />
              </picture>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default HomeWhyPureIonia;
